import { apiFetch } from './client';
import { assertArray, assertInformation } from './guards';

export enum InformationCategory {
  Info = 1,
  System = 2,
  Release = 3,
}

export interface Information {
  id: number;
  category: InformationCategory;
  subject: string;
  reference: string | null;
  publishedAt: string;
}

// TODO: in the codebase move all '/api/v1/' occurrences to a shared constant
export async function getInformations(): Promise<Information[]> {
  const raw = await apiFetch<unknown>('/api/v1/informations');
  assertArray(raw);
  for (const item of raw) {
    assertInformation(item);
  }
  return raw as Information[];
}
